import { BrowserRouter as Router, Routes, Route, Link, Redirect, Navigate } from 'react-router'
import { React, useEffect, useState } from 'react'

import './App.css'
import './MApp.css'


import Cookies from 'universal-cookie'

import Home from './pages/Home/Home'
import Page404 from './pages/Page404/Page404'


import { generateUUID, getBrowser } from './main.js'

// import Impressum from './pages/Impressum/Impressum.js'
import EventOverview from './pages/Events/EventOverview/EventOverview.js'
import PageNotYet from './pages/PageNotYet/PageNotYet.js'
import EventRegister from './pages/Events/EventRegister/EventRegister.js'
import MailVerification from './pages/MailVerification/MailVerification.js'
import EventRegisterSchedule from './pages/Events/EventRegisterSchedule/EventRegisterSchedule.js'
import EventRegisteredSchedule from './pages/Events/EventRegisteredSchedule/EventRegisteredSchedule.js'
import EventRegisterThanks from './pages/Events/EventRegisterThanks/EventRegisterThanks.js'
import Login from './pages/Login/Login.js'
import LoginVerification from './pages/LoginVerification/LoginVerification.js'
import ProfilOverview from './pages/Profil/ProfilOverview/ProfilOverview.js'
import ProfilSecurity from './pages/Profil/ProfilSecurity/ProfilSecurity.js'
import ProfilMessages from './pages/Profil/ProfilMessages/ProfilMessages.js'
import ManageOrganization from './pages/Manage/ManageOrganization/ManageOrganization.js'
import ManageOrganizationEdit from './pages/Manage/ManageOrganizationEdit/ManageOrganizationEdit.js'
import ManageEvent from './pages/Manage/ManageEvent/ManageEvent.js'
import ManageEventAttendees from './pages/Manage/ManageEventAttendees/ManageEventAttendees.js'
import ManageEventSchedulePlan from './pages/Manage/ManageEventSchedulePlan/ManageEventSchedulePlan.js'
import EventPlannedSchedule from './pages/Events/EventPlannedSchedule/EventPlannedSchedule.js'
import ManageEventMailings from './pages/Manage/ManageEventMailings/ManageEventMailings.js'
import LoginPW from './pages/LoginPW/LoginPW.js'
import Register from './pages/Register/Register.js'
import ProfilEdit from './pages/Profil/ProfilEdit/ProfilEdit.js'
import VerifyNewEmail from './pages/VerifyNewEmail/VerifyNewEmail.js'
import ManageEventEdit from './pages/Manage/ManageEventEdit/ManageEventEdit.js'
import ManageEventSchedule from './pages/Manage/ManageEventSchedule/ManageEventSchedule.js'
import EventList from './pages/Events/EventList/EventList.js'
import Faq from './pages/Faq/Faq.js'
import AdminOverview from './pages/Admin/AdminOverview/AdminOverview.js'
import AdminOrganizationCreate from './pages/Admin/AdminOrganizationCreate/AdminOrganizationCreate.js'
import AdminMailing from './pages/Admin/AdminMailing/AdminMailing.js'


const cookies = new Cookies()

export default function App() {
    useEffect(() => {
        try {
            // window.screen.orientation.lock("portrait")
        } catch (e) {
            console.log(e)
        }
    }, [])

    let cur_userid = cookies.get('userid')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var agentinfo = getBrowser(navigator.userAgent)
    var location = window.location

    // console.log(agentinfo.browser)
    // console.log(agentinfo.agent)
    // console.log(location.pathname)

    return (
        <Router>
            {/* basename={'/'} */}
            <Routes>
                {/* <Route path="/login" element={<Login />} /> */}
                <Route path="/login" element={<Login />} />
                <Route path="/login-pw" element={<LoginPW />} />
                <Route path="/event/:eventid" element={<EventOverview />} />
                <Route path="/eventregisterschedule/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/eventregisterschedule"} /> : <EventRegisterSchedule />} />
                <Route path="/eventregisteredschedule/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/eventregisteredschedule"} /> : <EventRegisteredSchedule />} />
                <Route path="/eventplannedschedule/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/eventplannedschedule"} /> : <EventPlannedSchedule />} />

                <Route path="/eventregisterthanks/:eventid" element={<EventRegisterThanks />} />
                <Route path="/eventregister/:eventid" element={<EventRegister />} />

                <Route path="/register" element={<Register />} />

                <Route path="/events/public/:orgid" element={<EventList />} />
                <Route path="/events/public" element={<EventList />} />
                <Route path="/events/listall" element={<EventList />} />

                {/* <Route path="/verifymail" element={(loggedin) ? <Navigate to={"/profil"} from={"/"} /> : <MailVerification />} /> */}
                <Route path="/verifymail" element={<MailVerification />} />
                {/* <Route path="/verifylogin" element={(loggedin) ? <Navigate to={"/profil"} from={"/login"} /> : <LoginVerification />} /> */}
                <Route path="/verifylogin" element={<LoginVerification />} />
                <Route path="/verifynewemail" element={<VerifyNewEmail />} />
                <Route path="/eventschedule/:eventid" element={<PageNotYet />} />
                <Route path="/events/*" element={<PageNotYet />} />

                {/* <Route path="/impressum" component={Impressum} /> */}
                <Route path="/profil" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ProfilOverview />} />
                <Route path="/profil/messages" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil/messages"} /> : <ProfilMessages />} />
                <Route path="/profil/messages/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil/messages"} /> : <ProfilMessages />} />
                <Route path="/profil/edit" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil/edit"} /> : <ProfilEdit />} />
                <Route path="/profil/sicherheit" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil/sicherheit"} /> : <ProfilSecurity />} />
                <Route path="/profil/setpw" element={<Navigate to={"/profil/sicherheit" + window.location.search} replace />} />
                <Route path="/profil*" element={<PageNotYet />} />

                {/* TODO set from dynamically to use it after login to navigate.from */}
                <Route path="/manage/org/:orgid/edit" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageOrganizationEdit />} />
                <Route path="/manage/org/:orgid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageOrganization />} />
                {/* <Route path="/manage/event/edit/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEventEdit />} /> */}

                <Route path="/manage/event/edit/" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEventEdit />} />
                <Route path="/manage/event/edit/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEventEdit />} />

                <Route path="/manage/eventschedule/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEventSchedule />} />

                <Route path="/manage/event/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEvent />} exact />
                <Route path="/manage/eventattendees/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEventAttendees />} />
                <Route path="/manage/eventscheduleplan/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEventSchedulePlan />} />
                <Route path="/manage/eventmailings/:eventid" element={(!loggedin) ? <Navigate to={"/login"} from={"/profil"} /> : <ManageEventMailings />} />
                <Route path="/manage/*" element={<PageNotYet />} />

                <Route path="/admin" element={(!loggedin) ? <Navigate to={"/login"} from={"/admin"} /> : <AdminOverview />} />
                <Route path="/admin/org/new" element={(!loggedin) ? <Navigate to={"/login"} from={"/admin"} /> : <AdminOrganizationCreate />} />
                <Route path="/admin/mailing" element={(!loggedin) ? <Navigate to={"/login"} from={"/admin"} /> : <AdminMailing />} />

                <Route path="/" element={<Home />} exact />
                <Route path="/faq" element={<Faq />} />
                <Route path="/hilfe" element={<Faq />} />
                <Route path="/*" element={<Page404 />} />
                <Route element={<Page404 />} />
            </Routes>
        </Router >
    )
}

